<template>
  <div class="card">
    <!-- <login-form :show="showLoginBox" :user="user" :flash="flash" @open="openLoginForm" ref="loginForm"></login-form> -->
     <div v-if="hasAccount" class="has-account-box">
      {{ $t('customerForm.not') }}
      {{ inputFirstName }}?
      <a @click="logoutSubmit">{{ $t('customerForm.signOut') }}</a>
    </div>

    <form @submit.prevent="nextStep('customer-form')" data-vv-scope="customer-form" novalidate ref="customerForm">
      <div class="customer-form" v-if="!isCorporate">
        <h2 class="margin-t-z margin-b-s">{{ $t('customerForm.yourInfo') }}</h2>

        <div class="row">
          <div class="medium-6 columns padding-r-s small-padding-h-z">
            <div :class="['field-group', {'field-error': error.firstName}]">
              <label class="field-label">{{ $t('customerForm.firstName') }} ({{inputFirstName.length}}/30)</label>
              <input type="text" name="fname" placeholder="John" :disabled="userLoggedIn" 
                :class="['field-text', (userLoggedIn ? 'disabled' : '')]" maxlength="30"
                v-model="inputFirstName" autofocus="!userLoggedIn" @change="gtagTrack('First Name', inputFirstName)" />
              <span v-show="error.firstName" class="field-error-message">{{error.firstName }}</span>
            </div>
          </div>
          <div class="medium-6 columns padding-l-s small-padding-h-z">
            <div :class="['field-group', {'field-error': error.lastName}]">
              <label class="field-label">{{ $t('customerForm.lastName') }} ({{inputLastName.length}}/30)</label>
              <input type="text" name="lname" placeholder="Doe" :disabled="userLoggedIn" 
                :class="['field-text', (userLoggedIn ? 'disabled' : '')]"  maxlength="30"
                v-model="inputLastName" @change="gtagTrack('Last Name', inputFirstName)" />
              <span v-show="error.lastName" class="field-error-message">{{ error.lastName }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="medium-12 columns">
            <div :class="['field-group', {'field-error': error.email}]">
              <label class="field-label">{{ $t('common.email') }}</label>
              <input type="email" name="email" placeholder="johndoe@gmail.com" 
                :class="['field-text', (userLoggedIn ? 'disabled' : '')]" 
                :disabled="userLoggedIn" v-model="inputEmail"
                @change="gtagTrack('Email', inputFirstName)" />
              <span v-show="error.email" class="field-error-message">{{ error.email }}</span>
            </div>
          </div>
        </div>
        <!-- <div class="row" v-if="!userLoggedIn">
          <div class="medium-12 columns">
            <div :class="{'field-group':true, 'field-error': error.confirmEmail}">
              <label class="field-label">{{ $t('customerForm.confirmEmail') }}</label>
              <input type="email" name="confirmEmail" placeholder="johndoe@gmail.com" 
                :class="['field-text', (userLoggedIn ? 'disabled' : '')]"
                :disabled="userLoggedIn" v-model="confirmEmail" />
              <span v-show="error.confirmEmail" class="field-error-message">{{ error.confirmEmail }}</span>
            </div>
          </div>
        </div> -->
        <div class="row">
          <div class="medium-12 columns margin-b-s">
            <mobile-input :needVerification="true" :mobile="mobile"
            @verified="mobileVerified" @updateMobile="updateMobileInfo" ref="userMobile" 
            @emptyPhone="mobile = ''"
            :dialCode="dialCode" :required="true":checkUser="true"
            @loginUser="loginUser" @nonUser="nonUser"></mobile-input>
          </div>
        </div>
      </div>

      <guest-form @clicked="enableGuestForm" @valid="validGuestForm" @updateInfo="guestUpdateInfo" ref="guestForm"></guest-form>
      <div v-show="!isCorporate">
        <password-form @clicked="clickedCreateAccount" @valid="isPasswordValid" ref="userPassword" v-show="!userLoggedIn"></password-form>
      </div>

      <span @click="adaTrigger = !adaTrigger">
        <icon name="wheelchair" :class="{'accessible':true, 'active':adaTrigger}"></icon>
      </span>
      <span>
        <transition name="slide-fade">
          <div v-show="adaTrigger" class="adaWrap">
            <div class="row">
              <div class="medium-12 columns margin-b-xs">
                <label class="ada">
                  <input type="checkbox" id="wheelChair" @change="updateAda"
                    v-model="wheelChair" />
                  {{ $t('customerForm.iHaveWheelchair') }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="medium-12 columns">
                <label class="ada">
                  <input type="checkbox" id="serviceDog" @change="updateAda"
                    v-model="serviceDog" />
                  {{ $t('customerForm.iHaveServiceDog') }}
                </label>
              </div>
            </div>
          </div>
        </transition>
      </span>

      <div :class="['margin-b-s showhide-fadeslide margin-t-xs', {'hide':!signupFail}]">
        <div class="alert error">
          <span v-if="!emailExistsError">{{ signupFailMessage }}</span>
          <span v-if="emailExistsError">
            {{ $t('customerForm.emailExist') }}
            <a href="javascript:;" v-on:click="forceShowForm">{{ $t('customerForm.clickHere') }}</a> 
            {{ $t('customerForm.toSignIn') }}
            <br/>
            {{ $t('customerForm.otherwisePlease') }}
          </span>
        </div>
      </div>

      <div class="row">
        <div class="small-6 columns margin-t-m page-actions-wrap">
          <a href="#/service" class="op-btn btn-lg btnBack" @click="backToServiceSelection($event)">
            <icon name="chevron-left" class="margin-r-xs"></icon>
            {{ $t('common.back') }}
          </a>
          <label class="margin-t-xs">
            {{ $t('customerForm.previous') }}
            {{ $t('customerForm.serviceSelection') }}
          </label>
        </div>
        <div class="small-6 columns margin-t-m page-actions-wrap text-right">
          <a href="#/payment" :class="['op-btn btn-success btn-lg btnContinue', {loading: signupLoading}]" @click="submitForm($event)">
            {{ $t('common.continue') }}
            <icon name="chevron-right" class="margin-l-xs" v-show="!signupLoading"></icon>
            <span class="loaderx margin-l-xs" v-show="signupLoading">
              <icon name="refresh" spin class="magin-r-xs"></icon>
            </span>
          </a>
          <label class="margin-t-xs">
            {{ $t('common.next') }}
            {{ $t('customerForm.paymentDetails') }}
          </label>
          <button type="submit" ref="submitBtn" v-show="false"></button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import LoginForm from './LoginForm.vue'
import GuestForm from './GuestForm.vue'
import PasswordForm from './PasswordForm.vue'
import MobileInput from '../Global/MobileInput.vue'
import VeeValidate from 'vee-validate'
import { isValidNumber } from 'libphonenumber-js'
import ApiPickupType from '@/modules/api/pickup-type'
import Freshchat from '@/modules/api/freshchat'

Vue.use(VeeValidate)

export default {
  name: 'customer-form',
  props: [ 'user', 'flash', 'backLink', 'showLoginBox' ],
  data: function () {
    return {
      isLoggedIn: false,
      doSignup: false,
      guestFormEnable: this.$store.state.guestInfo.proxy,
      guestAllValid: false,
      passwordValid: false,
      isMobileVerified: false,
      inputFirstName: this.userStore ? this.userStore.firstName : '',
      inputLastName: this.userStore ? this.userStore.lastName : '',
      inputEmail: this.userStore ? this.userStore.email : '',
      confirmEmail: this.userStore ? this.userStore.email : '',
      mobile: this.userStore ? this.userStore.phone.number : '',
      dialCode: this.userStore ? this.userStore.phone.code : '',
      mobileUserIpnut: '',
      mobileRequired: true,
      countryCode: '',
      passwordInput: '',
      guestFirstName: '',
      guestLastName: '',
      guestMobile: '',
      guestCountryCode: '',
      signupFail: false,
      signupFailMessage: '',
      signupLoading: false,
      emailExistsError: false,
      wheelChair: this.userStore ? this.userStore.ada.wheelChairLift : false,
      serviceDog: this.userStore ? this.userStore.ada.serviceDog : false,
      adaTrigger: false,
      error: {
        firstName: '',
        lastName: '',
        email: '',
        confirmEmail: ''
      },
      phoneLoggedIn: false,
      hideUserInfo: true,
      showVerificationForm: true,
      hasAccount: false
    }
  },
  components: {
    'login-form': LoginForm,
    'guest-form': GuestForm,
    'password-form': PasswordForm,
    'mobile-input': MobileInput
  },
  computed: {
    userStore () { return this.$store.state.user },
    userLoggedIn () { return this.userStore && !!this.userStore.token },
    _wheelChair () { return this.userStore.ada.wheelChairLift },
    _serviceDog () { return this.userStore.ada.serviceDog },
    isCorporate () { return this.userStore.isCorporate },
    guestPhone () { return this.userStore.guestPhone },
    guestFname () { return this.userStore.guestFname },
    guestLname () { return this.userStore.guestLname },
    mtech () { return this.$store.state.reservation.mtech },
    userToken () { return this.userStore.token },
    d2d () { return this.$store.state.reservation.d2d },
    bookingType () { return this.$store.state.reservation.bookingType }
  },
  methods: {
    nextStep (scope) {
      let self = this
      self.signupFail = false

      var mobileComponent = self.$refs.userMobile
      var passwordComponent = self.$refs.userPassword
      var guestComponent = self.$refs.guestForm
      var withErrors = false

      if (!self.isCorporate) {
        mobileComponent.triggerValidate()

        if (self.doSignup && !self.passwordValid) {
          withErrors = true
          passwordComponent.checkPasswordMatch(true)
        }
      }

      self.guestAllValid = self.guestFname && self.guestLname

      if ((self.guestFormEnable || self.isCorporate) && !self.guestAllValid) {
        withErrors = true
        guestComponent.validateGuestForm()
      }

      if (self.isCorporate) {
        guestComponent.validateGuestForm()

        let hasError = false
        if (self.guestFname.trim().length < 1) {
          hasError = true
          self.$store.commit('user/setGuestFname', '')
        }
        if (self.guestLname.trim().length < 1) {
          hasError = true
          self.$store.commit('user/setGuestLname', '')
        }
        if (self.guestPhone.trim().length < 1) {
          hasError = true
          self.$store.commit('user/setGuestPhone', '')
        }
        if (hasError) {
          guestComponent.validateGuestForm()
          return
        }

        if (!withErrors && self.guestPhone) {
          self.trackCustomerData()
          self.$root.$router.push('payment')
          self.$store.commit('setHasPassCustomerPage', true)

          // if (/*CONFIG.Env == 'production' &&*/ window.gtag) { // eslint-disable-line
          //   gtag('event', `Customer Continue`) // eslint-disable-line
          // }
        }
      } else {
        self.error = {
          firstName: '',
          lastName: '',
          email: '',
          confirmEmail: ''
        }
        if (!self.userToken) {
          if (!self.inputFirstName) {
            withErrors = true
            self.error.firstName = self.$t('common.fieldRequired', {field: 'first name'})
          }
          if (!self.inputLastName) {
            withErrors = true
            self.error.lastName = self.$t('common.fieldRequired', {field: 'last name'})
          }
          if (!self.inputEmail || !self.confirmEmail ||
            (self.inputEmail && self.confirmEmail && self.inputEmail !== self.confirmEmail)
          ) {
            withErrors = true
            if (!self.inputEmail) self.error.email = self.$t('common.fieldRequired', {field: 'email'})
            if (!self.confirmEmail) self.error.confirmEmail = self.$t('common.fieldRequired', {field: 'email'})
            if (self.inputEmail && self.confirmEmail && self.inputEmail !== self.confirmEmail) {
              self.error.confirmEmail = 'The email confirmation does not match.'
            }
          }
          let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (self.inputEmail && !pattern.test(self.inputEmail)) {
            withErrors = true
            self.error.email = self.$t('common.invalidEmail')
          }
          if (self.confirmEmail && !pattern.test(self.confirmEmail)) {
            withErrors = true
            self.error.confirmEmail = self.$t('common.invalidEmail')
          }
        }

        if (!withErrors) {
          if (self.userLoggedIn) {
            self.trackCustomerData()
            self.$root.$router.push('payment')
            self.$store.commit('setHasPassCustomerPage', true)
            // if (/*CONFIG.Env == 'production' &&*/ window.gtag) { // eslint-disable-line
            //   gtag('event', 'Customer Continue') // eslint-disable-line
            // }
          } else {
            if (self.doSignup) {
              if (!self.mobileUserIpnut || !self.isMobileVerified) { return }
              self.signupLoading = true
              self.$root.$emit('signup', {
                firstName: self.inputFirstName,
                lastName: self.inputLastName,
                email: self.inputEmail,
                password: self.passwordInput,
                phone: self.mobileUserIpnut,
                countryCode: self.countryCode,
                wheelChair: self.userStore.ada.wheelChairLift,
                serviceDog: self.userStore.ada.serviceDog
              })
            } else {
              if (!self.mobileUserIpnut || !self.isMobileVerified) { return }
              self.signupLoading = true
              self.$root.$emit('guestMode', {
                firstName: self.inputFirstName,
                lastName: self.inputLastName,
                email: self.inputEmail,
                phone: self.mobileUserIpnut,
                countryCode: self.countryCode,
                wheelChair: self.userStore.ada ? self.userStore.ada.wheelChairLift : false,
                serviceDog: self.userStore.ada ? self.userStore.ada.serviceDog : false
              })
            }
          }
        }
      }
    },
    mobileVerified: function (isVerified) { this.isMobileVerified = isVerified },
    updateMobileInfo: function (data) {
      this.mobileUserIpnut = data.mobile
      this.countryCode = data.countryCode

      let isUS = this.countryCode === 1
      this.setPickupType({isUS: isUS})
    },
    enableGuestForm: function (isChecked) { this.guestFormEnable = isChecked },
    guestUpdateInfo: function (data) {
      this.guestFirstName = data.firstName
      this.guestLastName = data.lastName
      this.guestMobile = data.mobile
      this.guestCountryCode = data.countryCode

      if (!data.checked) {
        let oldAda = this.$store.state.user.ada
        this.serviceDog = oldAda.loginServiceDog
        this.wheelChair = oldAda.loginWheelChairLift
        this.$store.commit('user/setAda', {
          serviceDog: oldAda.loginServiceDog,
          wheelChairLift: oldAda.loginWheelChairLift
        })
      } else {
        this.wheelChair = false
        this.serviceDog = false
        this.$store.commit('user/setAda', {
          serviceDog: false,
          wheelChairLift: false
        })
      }

      this.$store.commit('updateGuest', {
        proxy: data.checked,
        firstName: data.firstName,
        lastName: data.lastName,
        mobile: data.mobile,
        countryCode: data.countryCode
      })
    },
    validGuestForm: function (valid) { this.guestAllValid = valid },
    clickedCreateAccount: function (isChecked) {
      this.doSignup = isChecked
      this.$refs.loginForm.forceHideForm()
    },
    isPasswordValid: function (val) {
      this.passwordValid = val.match
      this.passwordInput = ''
      if (val.match) {
        this.passwordInput = val.password
      }
    },
    openLoginForm: function () {
      this.$refs.userPassword.forceHide()
      this.signupFail = false
    },
    forceShowForm: function () {
      this.$refs.loginForm.forceShowForm()
      this.signupFail = false
    },
    updateAda: function () {
      this.$store.commit('user/setAda', {
        serviceDog: this.serviceDog,
        wheelChairLift: this.wheelChair
      })
    },
    backToServiceSelection (event) {
      if (event) event.preventDefault()

      if (this.bookingType === 'flight') {
        this.$root.$router.push('d2ditinerary')
        return
      }

      this.$root.$router.push('service')
      window.location.href = '#/service'
    },
    setPickupType (data) {
      let self = this
      ApiPickupType.update(self, data, function (data) {
        if (data.action === 'mobileCCUpdate') {
          let rsvp = self.$store.state.reservation
          if (rsvp.leg1.isAirportPickup) {
            self.$root.$emit('mobileCCUpdate', {
              isUS: data.isUS,
              pickupType: rsvp.leg1.pickupType,
              fee: rsvp.leg1.pickupFee
            })
          }
          if (rsvp.isRoundtrip && rsvp.leg2.pickupHasAirline) {
            self.$root.$emit('mobileCCUpdate', {
              isUS: data.isUS,
              pickupType: rsvp.leg2.pickupType,
              fee: rsvp.leg2.pickupFee
            })
          }
        }
      })
    },
    submitForm (event) {
      if (event) event.preventDefault()
      if (this.$refs.submitBtn) {
        this.$refs.submitBtn.click()
      }
    },
    gtagTrack (field, val) {
      // if (CONFIG.Env == 'production' && window.gtag) { // eslint-disable-line
      //   gtag('event', field, { // eslint-disable-line
      //     value: val
      //   })
      // }
    },
    trackCustomerData () {
      // if (window.opoliCNS) {
      //   let guest = this.$store.state.guestInfo
      //   let rsvpData = this.$store.state.reservation
      //   let leg1 = rsvpData.leg1
      //   let leg2 = rsvpData.leg2
      //   let segment = {
      //     key: 'Customer Page',
      //     'First Name': this.userStore.firstName,
      //     'Last name': this.userStore.lastName,
      //     'Email': this.userStore.email,
      //     'Mobile Number': `${this.userStore.phone.code}${this.userStore.phone.number}`,
      //     'Booking for others': guest.proxy ? 'Yes' : 'No',
      //     'Others First Name': guest.firstName,
      //     'Others Last Name': guest.lastName,
      //     'Others Mobile Number': guest.mobile,
      //     'Create Account': this.doSignup ? 'Yes' : 'No',
      //     'Customer Page_Abandonment': 'No',
      //     'Customer Page_Continue': 'Yes',
      //     'Service Type': leg1.selectedService ? leg1.services[leg1.selectedService].brandedName : '',
      //     'Pickup Type': leg1.pickupType,
      //     'Pickup Date': leg1.pickupDate,
      //     'Leg 1': leg1.selectedService ? leg1.services[leg1.selectedService].prices[leg1.passenger + 1].price : '',
      //     'Leg 2': rsvpData.isRoundtrip && leg2.selectedService ? leg2.services[leg2.selectedService].prices[leg2.passenger + 1].price : '',
      //     'Total Price': '',
      //     'Pick Up Location': leg1.pickup.title,
      //     'Drop off Location': leg1.dropoff.title,
      //     'Flight Date': leg1.flightDate,
      //     'Pick Up Airline Info': `${leg1.airline} ${leg1.flightNo}`
      //   }
      //   if (leg1.isAsap) {
      //     segment['Pickup Date'] = 'ASAP'
      //   }
      //   this.$store.commit('tracking/setOpoliCnsData', {
      //     getTotal: {
      //       key: 'Customer Page',
      //       segment: segment,
      //       url: null,
      //       widgetEvent: true
      //     }
      //   })
      // }
    },
    parseCardClass (card) {
      let result = ''
      if (card.title === 'Visa') {
        result = 'visa'
      } else if (card.title === 'MasterCard' || card.title === 'Master Card') {
        result = 'mastercard'
      } else if (card.title === 'American Express') {
        result = 'amex'
      } else if (card.title === 'JCB') {
        result = 'jcb'
      } else if (card.title === 'Diners Club') {
        result = 'dinersclub'
      } else if (card.title === 'Discover') {
        result = 'discover'
      }
      return result
    },
    logoutSubmit () {
      this.hasAccount = false
      this.showVerificationForm = true
      this.$store.commit('user/setIsCorporate', false)
      this.$root.$emit('logout')
    },
    loginUser (userInfo) {
      this.phoneLoggedIn = true
      this.$root.$emit('applyLogin', userInfo)
      this.hideUserInfo = false
      this.showVerificationForm = false
      this.hasAccount = true
    },
    nonUser (data) {
      this.hideUserInfo = false
      this.showVerificationForm = false
      this.hasAccount = false
      if (data.loginVia === 'phone') {
        this.$store.commit('user/setUserPhone', {
          number: data.phone,
          code: data.countryCode
        })
        this.mobile = data.phone
        this.mobileUserIpnut = data.phone
        this.countryCode = data.countryCode
        this.dialCode = data.countryCode
        if (this.$refs.userMobile) this.$refs.userMobile.showHideForm(true)
      } else if (data.loginVia === 'email') {
        this.inputEmail = data.email
        this.mobile = this.userStore.phone.number || ''
        this.mobileUserIpnut = this.userStore.phone.number || ''
      }
    },
    getUserInfo (token) {
      let self = this
      self.phoneLoggedIn = false
      self.showVerificationForm = false
      self.hasAccount = false
      self.hideUserInfo = false
      self.$sdk.get(self, `/me?token=${token}`, {}, res => {
        if (!res.error) {
          res.token = token
          self.$root.$emit('applyLogin', res)
          self.hasAccount = true
          self.$store.commit('user/setEmailSubscribed', res.emailSubscribed === 1)

          if (res.corporateProfile && res.corporateProfile.discountCode) {
            self.$root.$emit('redeemCode', {code: res.corporateProfile.discountCode})
          }
          self.$root.$emit('getCards')
        }
      })
    },
    hideVeriForm () {
      this.showVerificationForm = false
      this.hideUserInfo = false
      this.hasAccount = true
    }
  },
  watch: {
    user: function (val) {
      let mobileComponent = this.$refs.userMobile
      if (this.$refs.userMobile && mobileComponent.reset()) {
        mobileComponent.reset()
      }

      if (val && val.firstName) {
        this.inputFirstName = val.firstName
        this.inputLastName = val.lastName
        this.inputEmail = val.email
        this.mobile = val.phone
        this.$store.commit('user/setAda', {
          serviceDog: val.ada && val.ada.serviceDog === 1,
          wheelChairLift: val.ada && val.ada.wheelChairLift === 1
        })
        this.$store.commit('user/setLoginAda', {
          serviceDog: val.ada && val.ada.serviceDog === 1,
          wheelChairLift: val.ada && val.ada.wheelChairLift === 1
        })

        this.dialCode = 999
        let self = this
        setTimeout(function () {
          self.dialCode = val.countryCode
        }, 10)
      }
    },
    _wheelChair: function (val) { this.wheelChair = val },
    _serviceDog: function (val) { this.serviceDog = val },
    inputFirstName: function (val) {
      if (val) this.error.firstName = ''
    },
    inputLastName: function (val) {
      if (val) this.error.lastName = ''
    },
    inputEmail: function (val) {
      if (val) this.error.email = ''
    },
    confirmEmail: function (val) {
      if (val) this.error.confirmEmail = ''
    }
  },
  mounted: function () {
    let self = this

    if (self.userStore) {
      if (self.userStore.token) self.$root.$emit('refreshCredits', self.userStore.token)

      if (self.userStore.firstName) self.inputFirstName = self.userStore.firstName
      if (self.userStore.lastName) self.inputLastName = self.userStore.lastName
      if (self.userStore.email) {
        self.inputEmail = self.userStore.email
        self.confirmEmail = self.userStore.email
      }

      if (self.userStore.phone && self.userStore.phone.number) {
        self.mobileUserIpnut = self.userStore.phone.number
        self.mobile = self.userStore.phone.number
        self.dialCode = self.userStore.phone.code
        let userPhone = '+' + self.userStore.phone.code + self.userStore.phone.number
        let notInternational = isValidNumber(userPhone, 'US') || isValidNumber(userPhone, 'CA')
        if (!self.mtech.enabled) {
          self.setPickupType({isUS: notInternational})
        }
      }
    }

    if (self.isCorporate && self.$store.state.hasPassCustomerPage && self.$refs.guestForm) {
      self.$refs.guestForm.validateGuestForm()
    }

    let user = self.userStore
    if (user.ada.serviceDog !== user.ada.loginServiceDog ||
      user.ada.wheelChairLift !== user.ada.loginWheelChairLift
    ) { self.adaTrigger = true }

    let _rsvp = this.$store.state.reservation.leg1
    if (_rsvp.pickup && _rsvp.pickup.title) {
      self.$store.commit('setCurrentIndex', 1)
      self.$store.commit('enablePreviousSteps', 1)
      self.$store.commit('setShowPaymentBreakdown', true)
      self.$store.commit('setShowPromoCodeInput', false)
    } else {
      this.backToServiceSelection()
    }

    self.$on('signupFlagChange', ev => { self.doSignup = ev.value })
    self.$on('mobileChange', ev => {
      self.mobile = ev.mobile
      self.countryCode = ev.countryCode
    })
    self.$root.$on('signupSuccess', ev => {
      self.$store.commit('user/setToken', ev.token)
      if (ev.mobile) { ev.phone = ev.mobile }
      self.$store.commit('user/setUserInfo', ev)
      self.$store.commit('user/setAda', {
        serviceDog: ev.serviceDog,
        wheelChairLift: ev.wheelChairLift
      })
      self.$store.commit('user/setLoginAda', {
        serviceDog: ev.serviceDog,
        wheelChairLift: ev.wheelChairLift
      })

      self.$sdk.get(self, '/me', { token: self.$store.state.user.token }, res => {
        if (!res.error) {
          self.$store.commit('user/setEmailSubscribed', res.emailSubscribed === 1)
        }
      })

      self.signupLoading = false
      self.signupFail = false
      self.trackCustomerData()
      self.$root.$router.push('payment')

      // if (self.$ga) {
      //   self.$ga.page({
      //     page: '/signup',
      //     title: 'Signup Page',
      //     screenName: 'signup'
      //   })
      // }
      // if (/*CONFIG.Env == 'production' &&*/ window.gtag) { // eslint-disable-line
      //   gtag('event', `Customer Continue`) // eslint-disable-line
      // }

      // Freshchat - Set user (SIGNUP/GUEST)
      Freshchat.setuser(self)
    })
    self.$root.$on('signupFailure', data => {
      self.signupLoading = false
      self.signupFail = true
      self.emailExistsError = data.message === 'E_EMAIL_EXISTS'
      self.signupFailMessage = data.message
      if (data.error && data.error.message) {
        self.emailExistsError = data.error.message === 'E_EMAIL_EXISTS'
        self.signupFailMessage = data.error.message
      }
    })
    self.$root.$on('logoutSuccess', function () {
      self.inputFirstName = ''
      self.inputLastName = ''
      self.inputEmail = ''
      self.mobile = ''

      self.$store.commit('user/reset')
      self.$store.commit('disablePreviousSteps', 2)
      self.$store.commit('disablePreviousSteps', 3)
      self.$store.commit('enablePreviousSteps', 1)

      if (self.$refs.userMobile && self.$refs.userMobile.changePhoneNumber()) {
        self.$refs.userMobile.changePhoneNumber()
      }

      if (window.fcWidget) {
        window.fcWidget.user.clear().then(function () {}, function () {})
      }
      ApiPickupType.update(self, {action: 'logout'}, function (data) {})
      self.$store.commit('cards/setCardData', {
        lastUserID: '',
        list: []
      })

      setTimeout(function () {
        self.errors.items = []
      }, 50)
    })
    self.$root.$on('loginSuccess', function (userInfo) {
      self.signupFail = false
      self.$store.commit('user/setToken', userInfo.token)

      let token = userInfo && userInfo.token ? userInfo.token : self.$store.state.user.token
      self.$sdk.get(self, `/me?token=${token}`, {}, res => {
        if (!res.error) {
          self.$store.commit('user/setEmailSubscribed', res.emailSubscribed === 1)

          if (res.corporateProfile && res.corporateProfile.discountCode) {
            self.$root.$emit('redeemCode', {code: res.corporateProfile.discountCode})
          }
          self.$root.$emit('getCards')
        }
      })

      self.$store.commit('user/setUserInfo', userInfo)

      self.$store.commit('user/setAda', {
        serviceDog: userInfo.ada ? userInfo.ada.serviceDog : false,
        wheelChairLift: userInfo.ada ? userInfo.ada.wheelChairLift : false
      })
      self.$store.commit('user/setLoginAda', {
        serviceDog: userInfo.ada ? userInfo.ada.serviceDog : false,
        wheelChairLift: userInfo.ada ? userInfo.ada.wheelChairLift : false
      })
      if (self.$refs.loginForm) self.$refs.loginForm.forceHideForm()

      // Freshchat - Set user (LOGIN)
      Freshchat.setuser(self)

      // if (self.$ga) {
      //   self.$ga.page({
      //     page: '/login',
      //     title: 'Login Page',
      //     screenName: 'loginPage'
      //   })
      // }
      // if (window.gtag) { // eslint-disable-line
      //   gtag('event', 'page_view', { // eslint-disable-line
      //     'page': 'Login page'
      //   })
      // }
      setTimeout(function () {
        self.$validator.validateAll('customer-form').then(result => {})
      }, 200)
    })
    self.$root.$emit('getCards')
    self.$root.$on('getCardsSuccess', function (cards) {
      let existingPayments = []

      if (typeof cards === 'undefined' || cards.length === 0) {
        // ..
      } else {
        for (let i = 0; i < cards.length; i++) {
          let card = cards[i]
          let className = self.parseCardClass(card)

          existingPayments.push({
            id: card.ID,
            type: card.title,
            number: card.cardNumber,
            exp: card.cardExpires,
            className: className
          })
        }
        // self.showPaymentDropdown = true
        self.$store.commit('cards/setCardData', {
          lastUserID: self.$store.state.user.id,
          list: existingPayments
        })
      }
    })

    // if (self.$ga) {
    //   self.$ga.page({
    //     page: '/customer',
    //     title: 'Customer Page',
    //     screenName: 'customerPage'
    //   })
    // }
    // if (window.gtag) { // eslint-disable-line
    //   gtag('event', 'page_view', { // eslint-disable-line
    //     'page': 'Customer page'
    //   })
    // }

    setTimeout(function () {
      let elmnt = document.getElementById('app')
      elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
    }, 200)
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/Customer/CustomerForm.scss";

h2{
	font-size: 1.5em!important;
  font-weight: 600!important;
}
.accessible{
  color: #bbb;
  &.active{ color: #777; }
}
.adaWrap{
  display: inline-block;
  margin-left: 5px;
  padding-left: 5px;
  vertical-align: top;
  border-left: 2px solid #eee;
}
.btnContinue, .btnBack{
  text-decoration: none!important;
}

.has-account-box{
  width: 100%;
  text-align: right;
  letter-spacing: .4px;
  font-size: 14px;

  a{
    cursor: pointer;
    font-weight: 600;
    margin-left: 5px
  }
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to{
  transform: translateX(-15px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// CustomerForm.vue?2cd0ffa5